module.exports = __webpack_public_path__ + "static/media/bzlogo.6431ecb2.png";